import React from 'react';

import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import Container from '@mui/material/Container';
import Tooltip from '@mui/material/Tooltip';
import Divider from '@mui/material/Divider';

import ExitToAppOutlinedIcon from '@mui/icons-material/ExitToAppOutlined';
import PersonOutlineIcon from '@mui/icons-material/PersonOutline';
import BusinessIcon from '@mui/icons-material/Business';

import Logo from '../Logo';

const ResponsiveAppBar = ({ isLoading, user, companyId, onLogout }) => {

  return (
    <AppBar position='sticky' >
      <Container maxWidth='xl'>
        <Toolbar>

          <Box sx={{mr: {xs: 2, sm: 4}}}>
            <Logo/>
          </Box>

          <Typography
            variant='h5'
            noWrap
            sx={{
              mr: 2,
              display: { xs: 'none', md: 'flex' },
              flexGrow: 1,
              color: 'inherit',
              fontWeight: 100,
            }}
          >
            Solicitação de Serviço
          </Typography>

          <Divider variant='middle' orientation='vertical' flexItem color='white' sx={{ml: 2, mr: 2, display: { xs: 'none', md: 'flex' }}}/>

          <Box sx={{ display: { xs: 'none', md: 'flex' }, flexDirection: 'column', justifyContent: 'center', alignItems: 'flex-start', ml: 1, mr: 1}}>
            <PersonOutlineIcon sx={{fontSize: 14}}/>
            <Typography sx={{ color: 'inherit', fontSize: 12 }}>
              {user}
            </Typography>
          </Box>

          <Divider variant='middle' orientation='vertical' flexItem color='white' sx={{ml: 2, mr: 2, display: { xs: 'none', md: 'flex' }}}/>

          <Box sx={{display: { xs: 'none', md: 'flex' }, flexDirection: 'column', justifyContent: 'center', alignItems: 'flex-start', ml: 1, mr: 1}}>
            <BusinessIcon sx={{fontSize: 14, display: { xs: 'none', md: 'flex' }}}/>
            <Typography sx={{ color: 'inherit', fontSize: 12 }}>
              {companyId}
            </Typography>
          </Box>

          <Divider variant='middle' orientation='vertical' flexItem color='white' sx={{ml: 2, mr: 2, display: { xs: 'none', md: 'flex' }}}/>

          <Typography
            noWrap
            sx={{
              mr: 2,
              display: { xs: 'flex', md: 'none' },
              flexGrow: 1,
              color: 'inherit',
            }}
          >
            SS
          </Typography>

          <Tooltip title='Sair'>
            <Box sx={{ flexGrow: 0 }}>
              <IconButton disabled={isLoading} onClick={onLogout} sx={{ p: 0, color: 'inherit' }}>
                <ExitToAppOutlinedIcon sx={{fontSize: 25}}/>
              </IconButton>
            </Box>
          </Tooltip>

        </Toolbar>
      </Container>
    </AppBar>
  );
};

export default ResponsiveAppBar;
